import { combineReducers } from 'redux';

import rules from './leadAssignmentRules.reducer';
import leadMatchSchema from './leadMatchSchema.reducer';
import leadPoolCriteriaSchema from './leadPoolCriteriaSchema.reducer';

const leadAssignmentRulesReducer = combineReducers({
  rules,
  leadMatchSchema,
  leadPoolCriteriaSchema,
});

export default leadAssignmentRulesReducer;
